<div class="edit-container">
    <h1 class="edit-title">Actualizare cont pre-înrolat</h1>

    <form class="edit-card__form" [formGroup]="form" (submit)="submitForm()">
        <div class="edit-field">
            <mat-form-field appearance="fill">
                <mat-label>ID Persoana</mat-label>
                <input type="number" matInput formControlName="persoana_id" />
            </mat-form-field>
            <mat-error *ngIf="!form.controls['persoana_id'].valid && form.controls['persoana_id'].touched">
                Câmp obligatoriu
            </mat-error>
        </div>

        <div class="edit-field">
            <mat-form-field appearance="fill">
                <mat-label>Nume</mat-label>
                <input type="text" matInput formControlName="nume" />
            </mat-form-field>
            <mat-error *ngIf="!form.controls['nume'].valid && form.controls['nume'].touched">
                Câmp obligatoriu
            </mat-error>
        </div>

        <div class="edit-field">
            <mat-form-field appearance="fill">
                <mat-label>Prenume</mat-label>
                <input type="text" matInput formControlName="prenume" />
            </mat-form-field>
            <mat-error *ngIf="!form.controls['prenume'].valid && form.controls['prenume'].touched">
                Câmp obligatoriu
            </mat-error>
        </div>

        <div class="edit-field">
            <mat-form-field appearance="fill">
                <mat-label>Telefon</mat-label>
                <input type="text" matInput formControlName="telefon" />
            </mat-form-field>
            <mat-error *ngIf="!form.controls['telefon'].valid && form.controls['telefon'].touched">
                Câmp obligatoriu
            </mat-error>
        </div>

        <div class="edit-field">
            <mat-form-field appearance="fill">
                <mat-label>Email</mat-label>
                <input type="text" matInput formControlName="email" />
            </mat-form-field>
            <mat-error *ngIf="!form.controls['email'].valid && form.controls['email'].touched">
                Câmp obligatoriu
            </mat-error>
        </div>

        <div class="edit-field">
            <mat-form-field appearance="fill">
                <mat-label>Pin</mat-label>
                <input type="text" matInput formControlName="pin" />
            </mat-form-field>
            <!-- <mat-error *ngIf="!form.controls['pin'].valid && form.controls['pin'].touched">
                Câmp obligatoriu
            </mat-error> -->
        </div>

        <div class="edit-field">
            <mat-form-field appearance="fill">
                <mat-label>CNP</mat-label>
                <input type="number" matInput formControlName="cnp" />
            </mat-form-field>
            <!-- <mat-error *ngIf="!form.controls['cnp'].valid && form.controls['cnp'].touched">
                Câmp obligatoriu
            </mat-error> -->
        </div>

        <div class="edit-field">
            <mat-form-field appearance="fill">
                <mat-label>CUI</mat-label>
                <input type="text" matInput formControlName="cui" />
            </mat-form-field>
        </div>

        <div class="edit-field">
            <mat-form-field appearance="fill">
                <mat-label>Nume firmă</mat-label>
                <input type="text" matInput formControlName="f_nume" />
            </mat-form-field>
        </div>

        <div class="edit-field">
            <mat-form-field appearance="fill">
                <mat-label>Nr. în registrul comerțului</mat-label>
                <input type="text" matInput formControlName="f_reg_com" />
            </mat-form-field>
        </div>

        <div class="d-flex justify-content-between">
            <button type="button" class="buttons" mat-flat-button (click)="closeDialog()">
                {{ helper.dialogConfig.buttonLabels.close }}
            </button>
            <button class="buttons" mat-flat-button color="primary" type="submit" [disabled]="form.invalid">
                {{ helper.dialogConfig.buttonLabels.save }}
            </button>
        </div>
    </form>
    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>